import { render, staticRenderFns } from "./UnitEdit.vue?vue&type=template&id=5ed61e5e"
import script from "./UnitEdit.vue?vue&type=script&lang=js"
export * from "./UnitEdit.vue?vue&type=script&lang=js"
import style0 from "./UnitEdit.vue?vue&type=style&index=0&id=5ed61e5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports